import { render, staticRenderFns } from "./ComisionCrear.vue?vue&type=template&id=446818f0"
import script from "./ComisionCrear.vue?vue&type=script&lang=js"
export * from "./ComisionCrear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports